// extracted by mini-css-extract-plugin
module.exports = {"PlainFeature":"wm_a bhs_b"};